import { EmailOutlined } from '@mui/icons-material';
import { Link, Typography, Box, Grid } from '@mui/material';

import './index.css';

import mintu from '../../assets/images/mintu.jpg';
import CodeforcesLogo from '../../assets/images/CodeforcesLogo.svg';

const LinkedinLogo = ({ width, height }) => {
  return (
    <svg
      width={width}
      height={height}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      data-supported-dps="24x24"
      fill="currentColor"
      focusable="false"
    >
      <path
        fill="rgb(10, 102, 194)"
        d="M20.5 2h-17A1.5 1.5 0 002 3.5v17A1.5 1.5 0 003.5 22h17a1.5 1.5 0 001.5-1.5v-17A1.5 1.5 0 0020.5 2zM8 19H5v-9h3zM6.5 8.25A1.75 1.75 0 118.3 6.5a1.78 1.78 0 01-1.8 1.75zM19 19h-3v-4.74c0-1.42-.6-1.93-1.38-1.93A1.74 1.74 0 0013 14.19a.66.66 0 000 .14V19h-3v-9h2.9v1.3a3.11 3.11 0 012.7-1.4c1.55 0 3.36.86 3.36 3.66z"
      ></path>
    </svg>
  );
};

const GitHubLogo = ({ width, height }) => {
  return (
    <svg
      width={width}
      height={height}
      aria-hidden="true"
      viewBox="0 0 16 16"
      version="1.1"
      fill="currentColor"
      data-view-component="true"
    >
      <path
        fill="black"
        d="M8 0c4.42 0 8 3.58 8 8a8.013 8.013 0 0 1-5.45 7.59c-.4.08-.55-.17-.55-.38 0-.27.01-1.13.01-2.2 0-.75-.25-1.23-.54-1.48 1.78-.2 3.65-.88 3.65-3.95 0-.88-.31-1.59-.82-2.15.08-.2.36-1.02-.08-2.12 0 0-.67-.22-2.2.82-.64-.18-1.32-.27-2-.27-.68 0-1.36.09-2 .27-1.53-1.03-2.2-.82-2.2-.82-.44 1.1-.16 1.92-.08 2.12-.51.56-.82 1.28-.82 2.15 0 3.06 1.86 3.75 3.64 3.95-.23.2-.44.55-.51 1.07-.46.21-1.61.55-2.33-.66-.15-.24-.6-.83-1.23-.82-.67.01-.27.38.01.53.34.19.73.9.82 1.13.16.45.68 1.31 2.69.94 0 .67.01 1.3.01 1.49 0 .21-.15.45-.55.38A7.995 7.995 0 0 1 0 8c0-4.42 3.58-8 8-8Z"
      ></path>
    </svg>
  );
};

const LeetCodeLogo = ({ width, height }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 95 111"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      class="h-full w-auto max-w-none"
    >
      <path
        d="M68.0063 83.0664C70.5 80.5764 74.5366 80.5829 77.0223 83.0809C79.508 85.579 79.5015 89.6226 77.0078 92.1127L65.9346 103.17C55.7187 113.371 39.06 113.519 28.6718 103.513C28.6117 103.456 23.9861 98.9201 8.72653 83.957C-1.42528 74.0029 -2.43665 58.0749 7.11648 47.8464L24.9282 28.7745C34.4095 18.6219 51.887 17.5122 62.7275 26.2789L78.9048 39.362C81.6444 41.5776 82.0723 45.5985 79.8606 48.3429C77.6488 51.0873 73.635 51.5159 70.8954 49.3003L54.7182 36.2173C49.0488 31.6325 39.1314 32.2622 34.2394 37.5006L16.4274 56.5727C11.7767 61.5522 12.2861 69.574 17.6456 74.8292C28.851 85.8169 37.4869 94.2846 37.4969 94.2942C42.8977 99.496 51.6304 99.4184 56.9331 94.1234L68.0063 83.0664Z"
        fill="#FFA116"
      ></path>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M41.1067 72.0014C37.5858 72.0014 34.7314 69.1421 34.7314 65.615C34.7314 62.0879 37.5858 59.2286 41.1067 59.2286H88.1245C91.6454 59.2286 94.4997 62.0879 94.4997 65.615C94.4997 69.1421 91.6454 72.0014 88.1245 72.0014H41.1067Z"
        fill="#B3B3B3"
      ></path>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M49.9118 2.02335C52.3173 -0.55232 56.3517 -0.686894 58.9228 1.72277C61.494 4.13244 61.6284 8.17385 59.2229 10.7495L16.4276 56.5729C11.7768 61.552 12.2861 69.5738 17.6453 74.8292L37.4088 94.2091C39.9249 96.6764 39.968 100.72 37.505 103.24C35.042 105.761 31.0056 105.804 28.4895 103.337L8.72593 83.9567C-1.42529 74.0021 -2.43665 58.0741 7.1169 47.8463L49.9118 2.02335Z"
        fill="black"
      ></path>
    </svg>
  );
};

const MonkeytypeLogo = ({ width, height }) => {
  return (
    <svg
      width={width}
      height={height}
      xmlns="http://www.w3.org/2000/svg"
      style={{ isolation: 'isolate' }}
      viewBox="-680 -1030 300 180"
      fill="rgb(226, 183, 20)"
    >
      <g>
        <path d="M -430 -910 L -430 -910 C -424.481 -910 -420 -905.519 -420 -900 L -420 -900 C -420 -894.481 -424.481 -890 -430 -890 L -430 -890 C -435.519 -890 -440 -894.481 -440 -900 L -440 -900 C -440 -905.519 -435.519 -910 -430 -910 Z"></path>
        <path d=" M -570 -910 L -510 -910 C -504.481 -910 -500 -905.519 -500 -900 L -500 -900 C -500 -894.481 -504.481 -890 -510 -890 L -570 -890 C -575.519 -890 -580 -894.481 -580 -900 L -580 -900 C -580 -905.519 -575.519 -910 -570 -910 Z "></path>
        <path d="M -590 -970 L -590 -970 C -584.481 -970 -580 -965.519 -580 -960 L -580 -940 C -580 -934.481 -584.481 -930 -590 -930 L -590 -930 C -595.519 -930 -600 -934.481 -600 -940 L -600 -960 C -600 -965.519 -595.519 -970 -590 -970 Z"></path>
        <path d=" M -639.991 -960.515 C -639.72 -976.836 -626.385 -990 -610 -990 L -610 -990 C -602.32 -990 -595.31 -987.108 -590 -982.355 C -584.69 -987.108 -577.68 -990 -570 -990 L -570 -990 C -553.615 -990 -540.28 -976.836 -540.009 -960.515 C -540.001 -960.345 -540 -960.172 -540 -960 L -540 -960 L -540 -940 C -540 -934.481 -544.481 -930 -550 -930 L -550 -930 C -555.519 -930 -560 -934.481 -560 -940 L -560 -960 L -560 -960 C -560 -965.519 -564.481 -970 -570 -970 C -575.519 -970 -580 -965.519 -580 -960 L -580 -960 L -580 -960 L -580 -940 C -580 -934.481 -584.481 -930 -590 -930 L -590 -930 C -595.519 -930 -600 -934.481 -600 -940 L -600 -960 L -600 -960 L -600 -960 L -600 -960 L -600 -960 L -600 -960 L -600 -960 L -600 -960 C -600 -965.519 -604.481 -970 -610 -970 C -615.519 -970 -620 -965.519 -620 -960 L -620 -960 L -620 -940 C -620 -934.481 -624.481 -930 -630 -930 L -630 -930 C -635.519 -930 -640 -934.481 -640 -940 L -640 -960 L -640 -960 C -640 -960.172 -639.996 -960.344 -639.991 -960.515 Z "></path>
        <path d=" M -460 -930 L -460 -900 C -460 -894.481 -464.481 -890 -470 -890 L -470 -890 C -475.519 -890 -480 -894.481 -480 -900 L -480 -930 L -508.82 -930 C -514.99 -930 -520 -934.481 -520 -940 L -520 -940 C -520 -945.519 -514.99 -950 -508.82 -950 L -431.18 -950 C -425.01 -950 -420 -945.519 -420 -940 L -420 -940 C -420 -934.481 -425.01 -930 -431.18 -930 L -460 -930 Z "></path>
        <path d="M -470 -990 L -430 -990 C -424.481 -990 -420 -985.519 -420 -980 L -420 -980 C -420 -974.481 -424.481 -970 -430 -970 L -470 -970 C -475.519 -970 -480 -974.481 -480 -980 L -480 -980 C -480 -985.519 -475.519 -990 -470 -990 Z"></path>
        <path d=" M -630 -910 L -610 -910 C -604.481 -910 -600 -905.519 -600 -900 L -600 -900 C -600 -894.481 -604.481 -890 -610 -890 L -630 -890 C -635.519 -890 -640 -894.481 -640 -900 L -640 -900 C -640 -905.519 -635.519 -910 -630 -910 Z "></path>
        <path d=" M -515 -990 L -510 -990 C -504.481 -990 -500 -985.519 -500 -980 L -500 -980 C -500 -974.481 -504.481 -970 -510 -970 L -515 -970 C -520.519 -970 -525 -974.481 -525 -980 L -525 -980 C -525 -985.519 -520.519 -990 -515 -990 Z "></path>
        <path d=" M -660 -910 L -680 -910 L -680 -980 C -680 -1007.596 -657.596 -1030 -630 -1030 L -430 -1030 C -402.404 -1030 -380 -1007.596 -380 -980 L -380 -900 C -380 -872.404 -402.404 -850 -430 -850 L -630 -850 C -657.596 -850 -680 -872.404 -680 -900 L -680 -920 L -660 -920 L -660 -900 C -660 -883.443 -646.557 -870 -630 -870 L -430 -870 C -413.443 -870 -400 -883.443 -400 -900 L -400 -980 C -400 -996.557 -413.443 -1010 -430 -1010 L -630 -1010 C -646.557 -1010 -660 -996.557 -660 -980 L -660 -910 Z "></path>
      </g>
    </svg>
  );
};

const AboutMe = () => {
  return (
    <div style={{ width: '100%' }}>
      <Grid container>
        <Grid item xs={12} sm={5}>
          <div
            className="MyImageDiv"
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              position: 'sticky',
              top: 0,
            }}
          >
            <img
              src={mintu}
              alt="Mintu Jupally"
              style={{
                objectFit: 'contain',
                width: '80%',
                borderRadius: '20px',
              }}
            />
          </div>
        </Grid>
        <Grid
          item
          xs={12}
          sm={7}
          style={{ padding: '1rem', paddingTop: '100px', paddingBottom: '2rem' }}
        >
          <Typography
            variant="h4"
            style={{ fontFamily: 'Playfair', textAlign: 'left', fontWeight: '800' }}
          >
            Sai Krishna Jupally
          </Typography>
          <Typography variant="h5" style={{ fontFamily: 'Playfair', textAlign: 'left' }}>
            Mintu Jupally
          </Typography>

          <Box style={{ height: '2rem' }}></Box>
          <Typography style={{ fontFamily: 'Open Sans', textAlign: 'left' }}>
            Computer Science Graduate from IIT Bhubaneswar. Curious by nature and enthusiastic to
            solve complex problems. Always eager to learn.
          </Typography>
          <Box style={{ height: '2rem' }}></Box>

          <Box
            style={{
              display: 'flex',
              alignItems: 'center',
              textDecoration: 'none',
              textTransform: 'none',
              color: 'rgb(82, 68, 59)',
              fontFamily: 'Open Sans',
              fontSize: '0.9rem',
            }}
            component={Link}
            href={'mailto:saikrishna.jupally@gmail.com'}
          >
            <EmailOutlined style={{ marginRight: '10px' }} />
            saikrishna.jupally@gmail.com
          </Box>
          <Box
            style={{
              display: 'flex',
              alignItems: 'center',
              textDecoration: 'none',
              textTransform: 'none',
              color: 'rgb(82, 68, 59)',
              fontFamily: 'Open Sans',
              fontSize: '0.9rem',
            }}
            component={Link}
            href={'mailto:mintu.jupally@gmail.com'}
          >
            <EmailOutlined style={{ marginRight: '10px' }} />
            mintu.jupally@gmail.com
          </Box>

          <Box style={{ height: '4rem' }}></Box>

          <Box>
            <div
              style={{
                border: '1px solid rgb(82, 68, 59)',
                borderRadius: '20px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                padding: '1rem',
                position: 'relative',
              }}
            >
              <div
                style={{
                  position: 'absolute',
                  top: '-0.8rem',
                  backgroundColor: 'rgb(232, 215, 205)',
                  padding: '0 1rem',
                  fontSize: '1.2rem',
                  borderRadius: '20px',
                }}
              >
                Find me at
              </div>
              <div
                style={{
                  display: 'flex',
                  margin: '0px 1rem',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginTop: '10px',
                  cursor: 'pointer',
                }}
                onClick={() => {
                  window.open('https://www.linkedin.com/in/sai-krishna-jupally/');
                }}
              >
                <LinkedinLogo height="50" />
              </div>
              <div
                style={{
                  display: 'flex',
                  margin: '0px 1rem',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginTop: '10px',
                  cursor: 'pointer',
                }}
                onClick={() => {
                  window.open('https://github.com/MintuJupally/');
                }}
              >
                <GitHubLogo height="50" />
              </div>
            </div>
          </Box>

          <Box style={{ height: '2rem' }}></Box>

          <Box>
            <div
              style={{
                border: '1px solid rgb(82, 68, 59)',
                borderRadius: '20px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                padding: '1rem',
                position: 'relative',
              }}
            >
              <div
                style={{
                  position: 'absolute',
                  top: '-0.8rem',
                  backgroundColor: 'rgb(232, 215, 205)',
                  padding: '0 1rem',
                  fontSize: '1.2rem',
                  borderRadius: '20px',
                }}
              >
                Other Profiles
              </div>
              <div
                style={{
                  display: 'flex',
                  margin: '0px 1rem',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginTop: '10px',
                  cursor: 'pointer',
                }}
                onClick={() => {
                  window.open('https://leetcode.com/mintujupally/');
                }}
              >
                <LeetCodeLogo height="50" width="50" />
              </div>
              <div
                style={{
                  display: 'flex',
                  margin: '0px 1rem',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginTop: '10px',
                  cursor: 'pointer',
                }}
                onClick={() => {
                  window.open('https://codeforces.com/profile/mintu.jupally');
                }}
              >
                <img src={CodeforcesLogo} height="50" width="50" alt="Codeforces Logo" />
              </div>
              <div
                style={{
                  display: 'flex',
                  margin: '0px 1rem',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginTop: '10px',
                  cursor: 'pointer',
                }}
                onClick={() => {
                  window.open('https://monkeytype.com/profile/mintujupally');
                }}
              >
                <MonkeytypeLogo height="40" width="50" />
              </div>
            </div>
          </Box>
        </Grid>
      </Grid>
    </div>
  );
};

export default AboutMe;
